// 表格转md 加async会报错，可能异步导致返回结果为空
export function htmlTableToMarkdown(htmlString) {
    // 使用正则表达式匹配HTML表格
    if (!htmlString || typeof htmlString !== "string") return
    const tableRegex = /<table>[\s\S]*?<\/table>/g
    const tableMatch = htmlString.match(tableRegex)

    if (tableMatch) {
        for (const i in tableMatch) {
            // 获取匹配到的HTML表格字符串
            const tableHtml = tableMatch[i]
            // 创建一个新的DOM解析器
            const parser = new DOMParser()
            // 解析HTML字符串
            const doc = parser.parseFromString(tableHtml, "text/html")
            const table = doc.querySelector("table")
            // 初始化Markdown字符串
            let markdownTable = ""

            // 遍历表格行
            for (const row of table.rows) {
                let markdownRow = "|"

                // 遍历行中的单元格
                for (const cell of row.cells) {
                    // 添加单元格内容，并确保两边有空格
                    markdownRow +=
                        cell.textContent.replace(/\|/g, "\\|").trim() + " |"
                }

                // 添加行到Markdown字符串
                markdownTable += markdownRow + "\n"

                // 添加分隔行
                if (row === table.rows[0]) {
                    let separator = "|"
                    for (let i = 0; i < row.cells.length; i++) {
                        separator += " --- |" // 可以根据需要添加更多或更少的破折号来表示对齐
                    }
                    markdownTable += separator + "\n"
                }
            }
            markdownTable = markdownTable

            // 替换原始HTML字符串中的表格为Markdown格式的表格
            htmlString = htmlString.replace(tableHtml, markdownTable)

        }
    }

    return htmlString
}